
import { Component, Prop, Ref } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import ProjectMixin from '@/_mixins/project'

import DropZone from '@/components/Picker/DropZone/DropZone.vue'
import Attachment from '@/_components/image/attachment.vue'

import Editor from '@/components/Editor/Editor.vue'

@Component({
    components: { DropZone, Attachment, Editor },
    mixins: [ProjectMixin],
})
export default class AddDocument extends Mixins<MixinInterface>(ProjectMixin) {
    dialog = true
    keepOpen = false

    // PROJECT DATA
    get isProject() {
        return this.$route.params.type != 'p'
    }

    get projectId() {
        return this.$route.params.type == 'p' ? this.$route.params.id : this.$route.query.projectId
    }

    get project() {
        return this.projectId ? this.$store.getters.project(this.projectId) : null
    }

    // NAME
    name: any = ''
    nameRules = [(v: any) => !!v || this.getTranslation('fe_hse_module.error_name_required')]

    // isPublic
    isPublic = false

    // DESCRIPTION
    tools = [
        'header',
        'linkTool',
        'list',
        'embed',
        'quote',
        'table',
        'delimiter',
        'Marker',
        'underline',
    ]
    description: any = null
    descriptionId = Date.now()
    passDescription(data: string) {
        this.description = data
    }

    // ATTACHMENT
    fileName: any = null
    fileId: any = null
    loadingFile = false
    counter = 0

    loadingAttachment(data: any) {
        this.loadingFile = data
    }

    dragenter(event: any) {
        event.preventDefault()
        this.counter++
        if (!event.currentTarget.classList.contains('drag-over')) {
            event.currentTarget.classList.add('drag-over')
        }
    }

    dragleave(event: any) {
        this.counter--
        if (this.counter === 0) {
            event.currentTarget.classList.remove('drag-over')
        }
    }

    async drop(event: any) {
        event.preventDefault()
        event.currentTarget.classList.remove('drag-over')
    }

    get requirments() {
        return this.$store.getters.attachmentConstraints.maxBytes
            ? this.$store.getters.attachmentConstraints
            : this.getFileRequirements()
    }

    get fileSize() {
        return this.requirments?.maxBytes
    }

    get allowedFileTypes() {
        return this.requirments?.allowedExtensions
            ? `.${this.requirments?.allowedExtensions.join(',.')}`
            : ''
    }

    passFiles(data: any) {
        this.fileId = data.attributes.fileId
    }

    async uploadFile(event: Event) {
        const input = event.target as HTMLInputElement

        if (input.files && input.files.length) {
            const [file] = input.files
            this.loadingFile = true
            this.fileName = file.name
            let res = await this.postFile(file).catch(() => {
                this.loadingFile = false
            })
            if (res) {
                this.fileId = res
            }
            this.loadingFile = false
        }
    }

    // POST
    loading = false
    valid = false
    async post(event: any) {
        event.preventDefault()
        if (this.valid) {
            this.loading = true
            let data = {
                type: 'hseDocument',
                attributes: {
                    name: this.name,
                    description: this.description,
                    fileId: this.fileId,
                    isPublic: this.isPublic,
                },
                relationships: {
                    project: {
                        data: {
                            id: this.projectId,
                            type: 'project',
                        },
                    },
                },
            }

            let res = await this.postHSEDocument(data).catch(() => {
                this.loading = false
            })

            this.$emit('postDocument', res)

            if (!this.keepOpen) {
                this.close()
            } else {
                this.name = ''
                this.fileId = null
                this.description = null
                this.descriptionId = Date.now()
            }
            this.loading = false
        }
    }

    close() {
        this.$router.push({
            name: 'hse-documents-settings',
            params: { projectId: this.$route.params.projectId },
        })
    }
}
